import { __awaiter } from "tslib";
import { useEffect, useRef } from 'react';
export const useFileUpload = ({ files, onChange }) => {
    const inputRef = useRef(null);
    useEffect(() => {
        if (!(files === null || files === void 0 ? void 0 : files.length) || !inputRef.current) {
            return;
        }
        const dt = new DataTransfer();
        files.forEach(f => dt.items.add(f.file));
        inputRef.current.files = dt.files;
    }, [files]);
    const onClickHandler = () => {
        if (!inputRef.current) {
            return;
        }
        inputRef.current.click();
    };
    const onChangeHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!inputRef.current) {
            return;
        }
        const { current: input } = inputRef;
        if (input.value) {
            onChange(Array.from(input.files || []));
        }
    });
    return {
        inputRef,
        onClickHandler,
        onChangeHandler
    };
};
